import { z as zod } from 'zod'

export const DefaultSchemas = zod.object({
  outcomeCode: zod.string().nullable(),
  outcomeMessage: zod.string().nullable(),
  outcomeUserMessage: zod.string().nullable(),
})
